/**
 * Created by noOne on 14/02/2018.
 */


"use strict";

/**
 * @class
 */
export default class Test extends P3.Scene {
    constructor() {
        super();

        this._bgHolder = new PIXI.Container();
        this._holder = new PIXI.Container();
        this._uiHolder = new PIXI.Container();

        this._proj = new P3D.Projection(this._holder, Common.renderer);
        this._proj.ambientRGB.r = 0.2;
        this._proj.ambientRGB.g = 0.2;
        this._proj.ambientRGB.b = 0.2;
        this._proj._farClipPlane = 100000;
        this._camera = this._proj.camera;

        this._orbitAngle = 0;
        this._orbitDist = 15;
        this._isOrbiting = true;
        this._model = null;
        this._time = 0;

    }

    init() {

        this.addChild(this._bgHolder, this._holder, this._uiHolder);

        //adjust light direction
        this._proj.lightDirection.y = -170;
        this._proj.lightDirection.x = 0;
        this._proj.lightDirection.z = -45;

        //move cam up a bit
        this._camera.position = {x: 0, y: 4, z: -11};
        this._camera.rotation = {x: -10, y: 0, z: 0};

        //add a model
        const a = P3.assets;
        const model = new P3D.Model(a.mesh("satellite"), a.texture);
        this._proj.addChild(model);
        model.y = -0.75;
        model.rotY = 90;

        this._model = model;

        //create a skybox, make sure to set its mesh culling to false and not to use lighting
        const cube = new P3D.Model(a.mesh("space"), a.texture);
        this._proj.addChild(cube);

        cube.scale.set(20000);
        // cube.y = -150;

        const myMesh = cube.findMesh("Cube");
        myMesh.culling = false;
        myMesh.useLighting = false;


    }

    update() {

        this._proj.update();

        //this._freeCam();

        if (this._isOrbiting) {
            this._orbitAngle += deltaTime * 0.1;
            this.orbitModel();
        }

        this._time += deltaTime * 0.5;

        this._camera.rotX += Math.sin(this._time) * 0.05;
        this._camera.y -= Math.sin(this._time) * 0.01;

    }

    orbitModel() {

        const rotCentre = new P3D.Vec3(this._model.x, this._model.y, this._model.z);

        //orbit around farm model
        orbit(this._camera, this._orbitDist, rotCentre, this._orbitAngle);

        //also rotate  so we are always looking towards model on y rotation
        const target = vec3.fromValues(rotCentre.x, rotCentre.y, rotCentre.z);
        const camPos = vec3.fromValues(this._camera.x, this._camera.y, this._camera.z);

        const direction = vec3.sub(vec3.create(), target, camPos);

        const angle = Math.atan2(direction[0], -direction[2]);
        this._camera.rotation.y = -angle * PIXI.RAD_TO_DEG;

        function orbit(point, distance, target, orbitAngle) {
            // calculate x, z from a vector with known length and angle
            const toX = distance * Math.cos(orbitAngle) + target.x;
            const toZ = distance * Math.sin(orbitAngle) + target.z;
            point.x += (toX - point.x) * 0.1;//distance * Math.cos(orbitAngle) + target.x;
            point.z += (toZ - point.z) * 0.1;//distance * Math.sin(orbitAngle) + target.z;
        }

    }


    _freeCam() {

        //handle keyboard input
        const rotSpeed = 120;
        if (P3.input.isKeyDown(65)) {    //rot left
            this._camera.rotation.y += rotSpeed * deltaTime;
        } else if (P3.input.isKeyDown(68)) {    //rot right
            this._camera.rotation.y -= rotSpeed * deltaTime;
        }

        let speed = 0;
        if (P3.input.isKeyDown(87)) {    //forward
            speed = 16;
        } else if (P3.input.isKeyDown(83)) {    //back
            speed = -16;
        }

        this._camera.x -= Math.sin(glMatrix.toRadian(this._camera.rotation.y)) * speed * deltaTime;
        this._camera.z -= Math.cos(glMatrix.toRadian(this._camera.rotation.y)) * speed * deltaTime;

        let riseSpeed = 0;
        if (P3.input.isKeyDown(90)) {    //up
            riseSpeed = 20;
        } else if (P3.input.isKeyDown(88)) {    //down
            riseSpeed = -20;
        }

        if (P3.input.isKeyDown(38)) {    //forward
            this._camera.rotation.x -= 8 * deltaTime;
        } else if (P3.input.isKeyDown(40)) {    //back
            this._camera.rotation.x += 8 * deltaTime;
        }

        this._camera.y += riseSpeed * deltaTime;

        if (P3.input.isKeyPressed(32)) {//log pos and rot on spacebar down
            // console.log("pos", this._camera.position);
            //  console.log("rot", this._camera.rotation);
            console.log(this.emitter.countAlive());
        }

    }

    destroy() {
        super.destroy({children: true});
        TweenMax.killAll();
    }

    appear() {
        super.appear();
    }

    end() {
        this.signals.next.dispatch(this);
    }

    resize() {
        this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
    }
}

